import axios from "axios";

const BASE_URL = "https://hrmsnew.prepstripe.com/api";

// Fetch all permissions
export const fetchPermissions = async (token) => {
  try {
    const response = await axios.get(`${BASE_URL}/permissions`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.permissions;
  } catch (error) {
    throw error.response.data;
  }
};

// Create a new permission
export const createPermission = async (token, data) => {
  try {
    const response = await axios.post(`${BASE_URL}/permissions`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.permission;
  } catch (error) {
    throw error.response.data;
  }
};

// Get details of a specific permission
export const getPermissionDetails = async (token, permissionId) => {
  try {
    const response = await axios.get(`${BASE_URL}/permission/${permissionId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.permission;
  } catch (error) {
    throw error.response.data;
  }
};

// Update a specific permission
export const updatePermission = async (token, permissionId, data) => {
  try {
    const response = await axios.put(
      `${BASE_URL}/permissions/${permissionId}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response.data.permission;
  } catch (error) {
    throw error.response.data;
  }
};

// delete a specific permission
export const deletePermission = async (token, permissionId) => {
  try {
    await axios.delete(`${BASE_URL}/permissions/${permissionId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    // return response.data.permission;
  } catch (error) {
    throw error.response.data;
  }
};
